import { Component } from '@angular/core';
import {
  MagicButtonComponent,
  MagicIconButtonComponent,
} from '@flowkit/button';

@Component({
  selector: 'app-my-magic-buttons',
  imports: [MagicButtonComponent, MagicIconButtonComponent],
  template: `
    <div>
      <h2 class="heading-title--small">Magic</h2>
      <div class="flex gap-5">
        <button flkMagicIconButton [tooltip]="'Magic'"></button>
        <button
          flkMagicIconButton
          [tooltip]="'Magic'"
          [disabled]="true"></button>
        <button
          flkMagicIconButton
          [tooltip]="'Magic'"
          [loading]="true"></button>
        <button flkMagicButton>Magic</button>
        <button flkMagicButton [showIcon]="true">Magic</button>
        <button flkMagicButton [disabled]="true">Magic</button>
        <button flkMagicButton [showIcon]="true" [disabled]="true">
          Magic
        </button>
        <button flkMagicButton [loading]="true">Magic</button>
      </div>
    </div>
  `,
})
export class MagicButtonsComponent {}
